'use strict';

import SearchContentHighlight from './highlight/search/SearchContentHighlight';
import { trackAction } from 'helpers/trackingOM';
import UrlHelper from 'helpers/UrlHelper';
import GridImpressionTracking, { GridTracking } from 'shared/gridImpressionTracking';
import {
    showHideCloseButton,
    clearSearchInput,
    setSearchTerm,
    storeSearchTerm,
    anchorToItem,
} from 'helpers/searchPageHelper';

// START A/B TEST PLGRWEB-1647-SearchPage-Previous Searches
import { initializePreviousSearchInstance } from 'abTests/testClasses/SearchPagePreviousSearch';
// END A/B TEST PLGRWEB-1647-SearchPage-Previous Searches

import {
    // START A/B TEST PLGRWEB-1340 : Display show/movie titles on search
    SEARCH_TITLE_TEST_VARIANT,
    // END A/B TEST PLGRWEB-1340 : Display show/movie titles on search
} from 'abTests/AbTestsConstants';
import 'components/subnav';

import SearchSubNav from './searchSubNav';

//import searchSuggestionConfigurator from '../carousels/searchSuggestionConfigurator';
import getRecursiveConfigCarousels from '../carousels/getRecursiveConfigCarousels';
import presearchCarousels from '../carousels/presearchCarousels';

import searchSuggestionsTpl from 'templates/__searchSuggestions.tpl';
import SubnavScroll from './subnav';

import DMAService from '../services/DMAService';

export default class Search {
    constructor() {
        new SearchSubNav();
        this.currentRequest = null;
        this.extraParams = {};
        this.navKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];

        let dmaService = new DMAService();
        dmaService
            .getDMA()
            .then((data) => {
                if (data && data.dma) {
                    this.extraParams = data;
                    this.setExtraParams(this.extraParams);
                }
            })
            .catch((error) => {
                this.setExtraParams(this.extraParams);
                console.error('Failed to get DMA on Search Page:', error);
            });

        this.classHide = 'hide';
        this.brazeCampaignParams = { screenName: 'search' };
        this.searchWrapper = document.querySelector('#search');

        this.setAbTestTracking();
        this.impressionTracking = null;

        // unique identifier passed to all search track action calls
        this.displayId = uuid.v4();

        this.contentHighlight = new SearchContentHighlight(null, null, this.displayId);

        if (!this.searchWrapper) return;

        this.inputBarWrapper = this.searchWrapper.querySelector('.search__inputBar');
        this.inputWrap = this.searchWrapper.querySelector('.search__inputWrap');
        this.input = this.inputBarWrapper.querySelector('input');
        this.input.focus();
        this.resultsWrapper = this.searchWrapper.querySelector('.search__results');

        this.revealHandler = document.querySelectorAll('.js-search');
        this.closeHandler = this.searchWrapper.querySelector('.close');

        this.isContentHighlightEnabled = CBS?.Registry?.Features?.content_highlight_web_search;

        this.suggestedSearchSelected = '';
        this.searchFilterInView = [];
        this.searchIdInView = [];
        this.preSearchSuggestions = document.querySelector('.presearch-subnav');
        if (this.preSearchSuggestions) {
            this.__initializePreSearchSuggestions();
        }
        this.presearchCollectionResultsWrapper = document.querySelector('.bottom-components');

        // feature flag to enable search UX improvements
        this.searchUXImprovements = CBS?.Registry?.Features?.global_search_ux_improvements;
        if (this.searchUXImprovements) {
            // update global header to accommodate search UX design
            let globalHeader = document.querySelector('#global-header-container');
            if (globalHeader) globalHeader.classList.add('search_ux_design');
        }

        this.trendingRecommended = document.getElementById('trending-recommended');

        if (this.trendingRecommended) {
            this.trendingAnchorLinks = this.trendingRecommended
                .querySelector('.grid-view-container')
                .querySelectorAll('a');

            if (this.trendingAnchorLinks.length) {
                this.trackOnItemsClick(this.trendingAnchorLinks, 2, 'trackSearchCarouselSelect', {
                    posRowNum: '0',
                    rowHeaderTitle: 'Trending',
                    carouselModel: 'showRecommendationTrending',
                });
            }
        }

        Array.from(document.getElementsByClassName('badge-copy')).forEach((el) => {
            if (navigator.userAgent.indexOf('Win') != -1) {
                el.style.paddingBottom = '2px';
                el.style.paddingTop = '0px';
            }
        });

        Array.from(document.getElementsByClassName('live-badge')).forEach((el) => {
            if (navigator.userAgent.indexOf('Win') != -1) {
                el.style.marginTop = '0px';
            }
        });
        /**
         * Delay in milliseconds
         * The delay in milliseconds between the keystroke and when a search is performed.
         * A 0 is more responsive, but can increase load on server.
         *
         * @type {number}
         */
        this.delay = 300;

        /**
         * Min required characters before search is performed
         *
         * @type {number}
         */
        this.minChars = 1;

        /**
         * Holds the keystroke timeout
         *
         * @type {string}
         */
        this.keystrokeTimer = '';

        this.inProgress = false;
        this.suggestionInProgress = null;

        this.searchAction = null;

        // retain search results if user returns from detail page
        if (this.searchUXImprovements) {
            const self = this;
            setSearchTerm(this.input);
            if (this.input.value.length > 0) {
                let omInterval = setInterval(function () {
                    if (typeof om != 'undefined') {
                        self.checkInput();
                        clearInterval(omInterval);
                    }
                }, 400);
            }
        }

        this.initialize();
        if (CBS.Registry.Features.braze_sdk === true)
            import('shared/braze_events/events').then(({ onSearchPageView }) => {
                onSearchPageView('/search', this.brazeCampaignParams);
            });
    }

    setAbTestTracking() {
        let trackingExperiments = [];

        // then append the new optimizly experiments pulled through our XHR to utag data
        for (const test in CBS.AbtestResults) {
            trackingExperiments.push(`${test}:${CBS.AbtestResults[test]}`);
        }

        this.optimizely_exp = trackingExperiments.join('|');
    }

    setExtraParams(obj) {
        this.extraParams = obj;
    }

    /**
     * Initialize search component
     * - add event listeners to reveal and hide search ui
     */
    initialize() {
        this.onOmLoad(function () {
            try {
                this.trackState();
            } catch (e) {}
        });

        // track search start when user clicks input bar
        this.input.addEventListener('click', (e) => {
            this.trackEvent('trackSearchStart', {
                PageType: 'search',
                searchEventStart: 1,
                displayId: this.displayId,
            });
            // apply background styling when user clicks search box
            this.inputWrap.classList.add('user-focused');
        });

        this.input.addEventListener('focusout', (e) => {
            // reset background styling when user clicks away
            this.inputWrap.classList.remove('user-focused');
        });

        this.closeHandler.addEventListener('click', (e) => {
            e.preventDefault();
            let trackingData = {
                searchEventCancel: '1',
                PageType: 'search',
                searchTerm: this.input.value,
                displayId: this.displayId,
                searchFilterInView:
                    CBS.Registry?.user?.profile_type?.toUpperCase() === 'ADULT'
                        ? this.searchFilterInView
                        : '',
                searchIdInView: this.searchIdInView,
            };

            if (this.suggestedSearchSelected !== '') {
                trackingData.suggestedSearchTerm = this.suggestedSearchSelected;
            }

            this.trackEvent('trackSearchCancel', trackingData);

            this.__initPresearchCarousels();

            // clear current search input if user clicks "X"
            if (this.searchUXImprovements) {
                clearSearchInput(this.input);
                this.checkInput(false);
                return;
            }

            this.reset();
        });

        this.keystrokeHandler();

        // load suggestions (after back button navigation)
        if (this?.input?.value?.length > 0) {
            this.showSuggestions(this.input.value);
        }
    }

    /**
     * Reveal search UI
     */
    reveal() {}

    trackSearch(trackName, vars) {
        let screen_vars = {
            pageType: 'search',
            screenName: '/search/',
            searchTerm: this.input.value,
            searchEventStart: null,
        };

        Object.assign(screen_vars, vars);

        //trigger the tracking beacon
        trackAction(trackName, screen_vars);
    }

    /**
     * Reset search elements
     * - clean up input box
     * - clean up results
     * - hide search UI
     */
    reset() {
        //window.history.pushState('', '', pageUrl);

        if (document.referrer.includes('cbs.com')) {
            window.history.go(-1);
        } else {
            window.location.href = UrlHelper.getHomePageURL();
        }

        return false;
    }

    /**
     * Reset results wrapper only
     *
     */
    resetResultsWrapper() {
        if (this.resultsWrapper) {
            this.resultsWrapper.innerHTML = '';
        }
        if (this.presearchCollectionResultsWrapper) {
            this.presearchCollectionResultsWrapper.innerHTML = '';
        }
    }

    /**
     * Trigger window resize event to fix carousel rendering issues
     *
     */
    refreshUI() {
        window.dispatchEvent(new Event('resize'));
    }

    /**
     * Reset search input field
     *
     */
    resetInputField() {
        this.input.value = '';
    }

    /**
     * Event handler for keystroke within search input field
     *
     */
    keystrokeHandler() {
        this.input.addEventListener(
            'keyup',
            this.debounce((e) => {
                if (this.navKeys.indexOf(e.key) == -1) {
                    this.checkInput();
                }
            }, 500),
        );

        // immediately (no debounce) reset input if backspaced to empty
        this.input.addEventListener('keyup', (e) => {
            if (e.target.value.length < 1) {
                this.__clearPreSearchSuggestionResults();
                clearSearchInput(this.input);
            }
            // get suggested search terms from /contentsearch/suggestions.json endpoint
            if (
                CBS?.Registry?.Features?.mid_search_suggestions_enabled &&
                this?.input?.value?.length > 0
            ) {
                this.showSuggestions(this.input.value.trim());
            }
        });
    }

    checkInput(trackSearchCancel = true) {
        const self = this;
        // get input field value
        let inputValue = this.input.value.trim();

        // display the “X” when search field has text
        if (this.searchUXImprovements) {
            showHideCloseButton(inputValue.length, this.closeHandler);
        }

        //  if white spaces, clear input box so that placeholder text is displayed again
        if (inputValue.length === 0) {
            this.input.value = '';

            this.destroyImpressionTracking();
            this.__hidePreSearchSuggestions(false);
            this.hideCarousels(false);
            this.resetResultsWrapper();
            this.refreshUI();
            this.__clearPreSearchSuggestionResults();

            // Only track search cancel if user cleared input box by backspacing
            if (trackSearchCancel) {
                this.trackSearch('trackSearchCancel', {
                    searchEventCancel: '1',
                    displayId: this.displayId,
                });
            }
        }

        //reset ajax search
        if (this.searchAction) {
            this.inProgress = false;
            this.searchAction.abort();
        }

        // check length
        if (inputValue.length >= this.minChars && this.inProgress === false) {
            self.performSearch(inputValue);
        }
    }

    debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this,
                args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    /**
     * Handler for special keys
     * Skip execution for selected keys
     *
     * @desc For reference: https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
     * @param evt
     */
    keyCodeHandler(evt) {
        // esc key
        if (evt.keyCode === 27) {
            this.reset();
        }

        // general keys except enter (13) will skip execution
        if (evt.keyCode > 8 && evt.keyCode !== 13 && evt.keyCode < 46) {
            return false;
        }

        if (evt.keyCode > 90 && evt.keyCode < 96) {
            return false;
        }
    }

    /**
     * Send query to fetch matching results
     *
     * @param inputValue
     */
    showSuggestions(inputValue) {
        const self = this;

        const controller = new AbortController();
        const signal = controller.signal;

        // abort previously existing incomplete suggestions requests
        if (self.suggestionInProgress) {
            self.suggestionInProgress.abort();
        }

        self.suggestionInProgress = controller;

        fetch(CBS.Registry.region.prefix + `/search/suggestions/?term=${inputValue.url_encode()}`, {
            signal,
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Search Suggestion network response was not ok');
                }
                self.suggestionInProgress = null;
                return response.json();
            })
            .then((data) => {
                // has suggestions and input not empty
                if (data.length > 0 && self.input.value.length > 0) {
                    self.searchFilterInView = [];
                    self.searchIdInView = [];

                    // hide presearch subnav
                    const subNav = document.getElementById('subnav');
                    if (subNav) {
                        subNav.style.display = 'none';
                    }

                    // remove previous suggestions subnav
                    const suggestionsSubNav = document.getElementById('subnav--search-suggestions');
                    if (suggestionsSubNav) {
                        suggestionsSubNav.parentNode.removeChild(suggestionsSubNav);
                    }

                    // create new template with suggestions
                    let suggestionWrapper = document.createElement('div');
                    suggestionWrapper.innerHTML = searchSuggestionsTpl({
                        suggestions: data,
                    });

                    // insert them on page
                    self.inputBarWrapper.parentNode.insertBefore(
                        suggestionWrapper.firstChild,
                        self.inputBarWrapper.nextSibling,
                    );

                    // make them scrollable
                    const searchSuggestionsSubnav = document.getElementById(
                        'subnav--search-suggestions',
                    );
                    const subNavScroll = new SubnavScroll($(searchSuggestionsSubnav));
                    subNavScroll.setupSubNav();

                    // suggestion on click event
                    const searchSuggestionsSubNavAnchors =
                        searchSuggestionsSubnav.querySelectorAll('li a');
                    searchSuggestionsSubNavAnchors.forEach((anchor, index) => {
                        const anchorText = anchor.textContent ?? '';
                        const anchorId = anchor.dataset.gid ?? '';
                        const anchorMovieId = anchor.dataset.movieid ?? '';
                        const anchorShowId = anchor.dataset.showid ?? '';
                        const anchorMovieTitle = anchorMovieId ? anchorText : '';
                        const anchorShowTitle = anchorShowId ? anchorText : '';
                        const columnPos = index ?? '0';

                        // tracking
                        self.searchFilterInView.push(anchorText);
                        self.searchIdInView.push(anchorId);

                        anchor.addEventListener('click', (e) => {
                            e.preventDefault();
                            // remove active classes on suggestions
                            searchSuggestionsSubNavAnchors.forEach((a) => {
                                if (a !== e.target) {
                                    a.classList.remove('active');
                                }
                            });
                            let searchResultListingAction = 'trackSuggestedSearchResultUsed';
                            // un-selecting suggestion link, perform search on input value
                            if (e.target.classList.contains('active')) {
                                e.target.classList.remove('active');
                                self.checkInput();
                                self.suggestedSearchSelected = '';
                                searchResultListingAction = 'trackSuggestionDeselect';
                            } else {
                                // selecting suggestion link, perform search on suggestion text
                                e.target.classList.add('active');
                                self.performSearch(anchorText);
                                self.suggestedSearchSelected = anchorText;
                            }

                            let searchResultListingData = {
                                posRowNum: '0',
                                posColNum: columnPos,
                                menuOrientation: 'header',
                                pageName: 'search',
                                pageType: 'search',
                                screenName: '/search/',
                                searchTerm: this.input.value,
                                searchResultListing: '1',
                                searchFilterInView:
                                    CBS.Registry?.user?.profile_type?.toUpperCase() === 'ADULT'
                                        ? self.searchFilterInView
                                        : '',
                                searchIdInView: self.searchIdInView,
                                suggestedSearchTerm: self.suggestedSearchSelected,
                                midSearchSuggestedId: anchorId ?? '',
                                showSeriesId: anchorShowId,
                                movieId: anchorMovieId,
                                showSeriesTitle: anchorShowTitle,
                                movieTitle: anchorMovieTitle,
                                displayId: self.displayId,
                            };

                            this.trackEvent(searchResultListingAction, searchResultListingData);
                        });
                    });
                }
            })
            .catch((error) => {
                if (error.name === 'AbortError') {
                    console.log('Suggestion Fetch aborted');
                } else {
                    console.error('Suggestion Fetch error:', error);
                }
            });
    }

    /**
     * Send query to fetch matching results
     *
     * @param inputValue
     */
    performSearch(inputValue) {
        this.inProgress = true;

        let searchObj = {
            term: inputValue.url_encode(),
            ...this.extraParams,
        };

        //adjust show times to user timeZone
        let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        searchObj.timeZone = localTimeZone;

        this.searchAction = $.ajax({
            type: 'GET',
            url: CBS.Registry.region.prefix + '/search/lookup/',
            data: searchObj,
            dataType: 'json',
            success: (resp) => {
                this.__hidePreSearchSuggestions(true);
                this.displayResults(resp);

                if (this.searchUXImprovements) {
                    // if navigating back from a search, anchor to the previous clicked result
                    anchorToItem();
                }

                this.destroyImpressionTracking();
                this.createImpressionTracking();
            },
        });

        this.searchAction.done(() => {
            this.inProgress = false;

            Array.from(document.getElementsByClassName('badge-copy')).forEach((el) => {
                if (navigator.userAgent.indexOf('Win') != -1) {
                    el.style.paddingBottom = '2px';
                    el.style.paddingTop = '0px';
                }
            });

            Array.from(document.getElementsByClassName('live-badge')).forEach((el) => {
                if (navigator.userAgent.indexOf('Win') != -1) {
                    el.style.marginTop = '0px';
                }
            });
        });
    }

    hideCarousels(hide) {
        if (hide) {
            $('.js-le-carousel').fadeOut(0);
        } else {
            $('.js-le-carousel').fadeIn();
        }
    }

    destroyImpressionTracking() {
        if (this.impressionTracking) {
            this.impressionTracking.removeEvents();
            this.impressionTracking = null;
        }
    }

    createImpressionTracking() {
        let resultContainer = this.resultsWrapper.querySelector('.search__results--results');
        let liveContainer = this.resultsWrapper.querySelector('.search__results--live-results');

        let containers = [];

        if (liveContainer) {
            containers.push(liveContainer);
        }

        if (resultContainer) {
            containers.push(resultContainer);
        }

        let objTracking = {
            pageType: 'search',
            searchTerm: this.input.value,
        };

        this.impressionTracking = new GridImpressionTracking(
            containers,
            'searchResultsView',
            'searchResultsSelect',
            objTracking,
        );
    }

    /**
     * Display search results UI
     *
     */
    displayResults(resp, suggestedPreSearchResults = false) {
        const self = this;
        this.resultsWrapper.innerHTML = resp.html;

        let items2 = this.resultsWrapper.querySelectorAll('a[aa-link]');
        let noResults = this.resultsWrapper.querySelectorAll('.search__results--empty');

        let trackSearchListingData = {
            pageType: 'search',
            screenName: '/search/',
            searchTerm: this.input.value,
            displayId: this.displayId,
        };

        if (noResults.length) {
            this.hideCarousels(false);
            trackSearchListingData.searchEventNoResult = '1';
            trackSearchListingData.searchFilterInView = self.searchFilterInView;
            trackSearchListingData.searchIdInView = self.searchIdInView;
            this.trackEvent('trackNoSearchResults', trackSearchListingData);
        } else {
            this.hideCarousels(true);

            // START A/B TEST PLGRWEB-1340 : Display show/movie titles on search
            this.displaySearchResultTitles();
            // END A/B TEST PLGRWEB-1340 : Display show/movie titles on search

            //call tracking when do a search

            let onNowElements = this.resultsWrapper.querySelectorAll(
                '.search__results--live-results a',
            );
            onNowElements = [].slice.call(onNowElements);

            let onNowSearchCount = onNowElements
                .filter(function (el) {
                    return getComputedStyle(el).display !== 'none';
                })
                .length.toString();

            let resultsSearchCount = this.resultsWrapper
                .querySelectorAll('.search__results--results a')
                .length.toString();

            let $activeLink = $('.subnav__items a.active');
            let activeLinkText = $activeLink.text();
            let activeLinkGID = $activeLink.data('gid');
            let activeLinkShowId = $activeLink.data('movieid');
            let activeLinkMovieId = $activeLink.data('movieid');
            let anchorMovieTitle = activeLinkMovieId ? activeLinkText : '';
            let anchorShowTitle = activeLinkShowId ? activeLinkText : '';

            let searchResultListingData = {
                searchResultListing: '1',
                pageType: 'search',
                screenName: '/search/',
                searchTerm: self.input.value,
                onNowSearchCount,
                resultsSearchCount,
                displayId: self.displayId,
                suggestedSearchTerm: self.suggestedSearchSelected,
                midSearchSuggestedId: activeLinkGID ?? '',
                showSeriesId: activeLinkShowId,
                movieId: activeLinkMovieId,
                showSeriesTitle: anchorShowTitle,
                movieTitle: anchorMovieTitle,
                searchFilterInView:
                    CBS.Registry?.user?.profile_type?.toUpperCase() === 'ADULT'
                        ? self.searchFilterInView
                        : '',
                searchIdInView: self.searchIdInView,
            };

            if (suggestedPreSearchResults) {
                this.trackEvent('trackSuggestedSearchResultUsed', searchResultListingData);
            } else {
                this.trackEvent('trackSearchResultListing', searchResultListingData);
            }

            if (!suggestedPreSearchResults && this.isContentHighlightEnabled) {
                this.contentHighlight.initResults(items2);
            }
        }

        if (CBS.Registry.lazyImage !== undefined) {
            CBS.Registry.lazyImage.revalidate();
        }

        setTimeout(() => {
            for (let i = 0; i < items2.length; i++) {
                let o = items2[i];
                let aaLinkValues = $(o).attr('aa-link').split('|');

                let _posColNum = aaLinkValues[3] ?? '0';
                let title = aaLinkValues[4];
                let showId = aaLinkValues[5];
                let movieId = aaLinkValues[6];
                let contentLocked = aaLinkValues[23] !== '' ? aaLinkValues[23] : '0';
                let liveTvChannel = aaLinkValues[24];
                let stationCode = aaLinkValues[25];
                let isLive = aaLinkValues[27] ?? 'is not live';
                let isUpcoming = aaLinkValues[21] === 'upcoming-event';
                let itemParams = {};

                if ((liveTvChannel && stationCode) || isUpcoming) {
                    itemParams.showSeriesTitle = title;
                } else if (showId) {
                    itemParams.showSeriesId = showId;
                    itemParams.showSeriesTitle = title;
                } else if (isUpcoming) {
                    itemParams.showSeriesTitle = title;
                } else {
                    itemParams.movieId = movieId;
                    itemParams.movieTitle = title;
                }

                itemParams.contentLocked = contentLocked;
                itemParams.contentStatus = isLive;
                itemParams.liveTvChannel = liveTvChannel;
                itemParams.stationCode = stationCode;
                itemParams.isLive = isLive;

                let trackSearchResultData = {
                    posRowNum: '0',
                    posColNum: _posColNum,
                    showSeriesTitle: title,
                    contentLocked: contentLocked,
                    searchEventComplete: '1',
                    PageType: 'search',
                    searchTerm: this.input.value,
                    ...itemParams,
                };

                // call tracking when user clicks a search result item
                o.addEventListener('click', (e) => {
                    // store search term to retain results if user navigates back
                    if (this.searchUXImprovements) {
                        storeSearchTerm(this.input.value, o.getAttribute('id'));
                    }

                    let parent = e.target.closest('.search__results--display');
                    let prevSibling = parent.previousElementSibling;
                    let menuItemLabel = prevSibling.innerText.trim();

                    let $activeLink = $('.subnav__items a.active');
                    let activeLinkText = $activeLink.text();
                    let activeLinkGID = $activeLink.data('gid');
                    let activeLinkShowId = $activeLink.data('movieid');
                    let activeLinkMovieId = $activeLink.data('movieid');
                    let anchorMovieTitle = activeLinkMovieId ? activeLinkText : '';
                    let anchorShowTitle = activeLinkShowId ? activeLinkText : '';

                    self.suggestedSearchSelected = activeLinkText;

                    let obj = {
                        searchEventComplete: '1',
                        PageType: 'search',
                        searchTerm: this.input.value,
                        menuItemLabel: menuItemLabel,
                        rowHeaderTitle: menuItemLabel,
                        displayId: this.displayId,
                        optimizelyEp: CBS.Tracking.utag_data.optimizelyExp,
                        suggestedSearchTerm: self.suggestedSearchSelected,
                        midSearchSuggestedId: activeLinkGID ?? '',
                        showSeriesId: activeLinkShowId,
                        movieId: activeLinkMovieId,
                        showSeriesTitle: anchorShowTitle,
                        movieTitle: anchorMovieTitle,
                        searchFilterInView:
                            CBS.Registry?.user?.profile_type?.toUpperCase() === 'ADULT'
                                ? self.searchFilterInView
                                : '',
                        searchIdInView: self.searchIdInView,
                        ...itemParams,
                        ...trackSearchResultData,
                    };

                    if (this.optimizely_exp) {
                        obj = { ...obj, ...{ optimizely_exp: this.optimizely_exp } };
                    }

                    if (this.suggestedSearchSelected !== '') {
                        obj.suggestedSearchTerm = this.suggestedSearchSelected;
                    }

                    const badgeLabelElement = e.target.nextElementSibling;
                    if (
                        badgeLabelElement &&
                        badgeLabelElement.classList.contains('new-item-container')
                    ) {
                        obj.contentBadgeLabel = badgeLabelElement
                            .querySelector('.new-item')
                            .innerHTML.trim();
                    }

                    obj = Object.fromEntries(
                        Object.entries(obj).filter(([key, value]) => value !== ''),
                    );

                    this.trackEvent('trackSearchResult', obj);

                    // START A/B TEST PLGRWEB-1647-SearchPage-Previous Searches
                    //store this tile's movieContentId /showId into the local storage
                    //then sends to PHP store in cookie
                    const prevSearchInstance = initializePreviousSearchInstance();
                    if (prevSearchInstance) {
                        prevSearchInstance.storeThisTile(obj, e);
                    }
                    // END A/B TEST PLGRWEB-1647-SearchPage-Previous Searches
                });

                let img = o.querySelector('img');
                if (img) {
                    img.classList.add('reveal');
                }
            }

            const items = this.resultsWrapper.querySelectorAll('img');

            if (this.trendingRecommended) {
                if (items > 0) {
                    this.trendingRecommended.classList.add(this.classHide);
                } else {
                    this.trendingRecommended.classList.remove(this.classHide);
                }
            }
        }, 300);
    }

    onOmLoad(callback) {
        if (typeof om === 'undefined') {
            setTimeout(callback, 2000);
        } else {
            callback();
        }
    }

    trackState() {
        const getCopy = () => {
            const headerItems = document.querySelectorAll('.video-section-title');
            const copy = Array.from(headerItems).map((div) => div.innerHTML);
            let result = '';
            for (let i = 0; i < copy.length; i++) {
                result += copy[i].trim() + ', ';
            }
            return result;
        };
        const optionsAvailable = getCopy();

        om.trackState('/search/', {
            pageType: 'search',
            searchEventStart: '1',
            searchFilterInView: optionsAvailable,
        });
    }

    trackEvent(event, data) {
        try {
            if (typeof om != 'undefined') {
                om.trackAction(event, data);
            }
        } catch (e) {}
    }

    trackOnItemsClick(resp, index, trackType = 'trackSearchResult', vars = {}) {
        const self = this;

        for (let i = 0; i < resp.length; i++) {
            const item = resp[i];
            item.classList.add('reveal');
            item.addEventListener('click', (e) => {
                const parts = e.path[index].getAttribute('aa-link').split('|');

                if (item.href) {
                    vars.carouselLink = item.href;
                }
                if (parts) {
                    vars.posColNum = parts[3];
                    const obj =
                        !parts[10] || parts[10] !== 'movies'
                            ? {
                                  ...vars,
                                  showSeriesId: parts[9],
                                  showSeriesTitle: parts[4],
                                  carouselContentType: 'show',
                              }
                            : {
                                  ...vars,
                                  movieId: parts[9],
                                  movieTitle: parts[4],
                                  carouselContentType: 'movie',
                              };

                    self.trackSearch(trackType, obj);
                }
            });
        }
    }

    __initializePreSearchSuggestions() {
        const self = this;

        // Initialize event listener to load pre-search suggestions when clicked
        let preSearchCategories = document.querySelectorAll('.presearch-category');
        preSearchCategories.forEach((elem) => {
            elem.addEventListener('click', (e) => {
                e.preventDefault();

                let presearchComponents = document.querySelector('.presearch-components');
                let fallbackPresearchComponents = document.querySelector(
                    '.fallback-presearch-components',
                );

                if (presearchComponents) {
                    presearchComponents.innerHTML = '';
                }

                if (fallbackPresearchComponents) {
                    fallbackPresearchComponents.style.display = 'none';
                }

                // If user clicked currently active suggestion, clear and return to pre-search
                if (elem.classList.contains('active')) {
                    elem.classList.remove('active');
                    self.__clearPreSearchSuggestionResults();
                    return;
                } else {
                    // Remove active class
                    preSearchCategories.forEach((elem2) => {
                        elem2.classList.remove('active');
                        // Except on the currently clicked one, set active class
                        if (elem2 === elem) {
                            elem2.classList.add('active');
                        }
                    });
                }

                let data = {
                    gid: elem.dataset.gid,
                    category: elem.dataset.category,
                    searchSlug: elem.dataset.slug,
                };
                // load results for active suggestion
                self.__getPreSearchSuggestionCarousels(data);

                // add suggested search result tracking
                self.suggestedSearchSelected = elem.dataset.category;
            });

            // Add this suggestion tab in view for tracking
            self.searchFilterInView.push(elem.dataset.category);
            self.searchIdInView.push(elem.dataset.gid);
        });
    }

    __getPreSearchSuggestionCarousels(data) {
        this.hideCarousels(true);
        this.resetResultsWrapper();

        // Abort old ajax request if new one is made
        if (this.currentRequest != null) {
            this.currentRequest.abort();
        }

        this.currentRequest = $.ajax({
            type: 'GET',
            url:
                CBS.Registry.region.prefix +
                '/carousels/pre-search-collections/xhr/category/' +
                data.searchSlug +
                '/',
            dataType: 'json',
            success: (resp) => {
                this.currentRequest = null;
                // display results for suggested show genre
                new getRecursiveConfigCarousels(resp.result);
                resp.hubObj.pageType = 'search'; // make pageType search for tracking
                //__hub is defined in  search/index template
                __hub = resp.hubObj;
                __hub.presearchSuggestionSelected = data.category; //__hub is defined in  search/index template
            },
            error: () => {
                this.currentRequest = null;
            },
        });
    }

    __clearPreSearchSuggestionResults() {
        const self = this;
        self.suggestedSearchSelected = '';
        self.hideCarousels(false);
        self.resetResultsWrapper();
        self.refreshUI();
        self.__initPresearchCarousels();

        // reset tracking
        self.searchFilterInView = [];
        self.searchIdInView = [];
        let preSearchCategories = document.querySelectorAll('.presearch-category');
        preSearchCategories.forEach((elem) => {
            self.searchFilterInView.push(elem.dataset.category);
            self.searchIdInView.push(elem.dataset.gid);
        });

        // remove previous suggestions subnav
        const suggestionsSubNav = document.getElementById('subnav--search-suggestions');
        if (suggestionsSubNav) {
            suggestionsSubNav.parentNode.removeChild(suggestionsSubNav);
        }

        // show presearch subnav
        const subNav = document.getElementById('subnav');
        if (subNav) {
            subNav.style.display = 'flex';
        }
    }

    __initPresearchCarousels() {
        if (typeof presearchConfig !== 'undefined') {
            presearchCarousels();
        } else {
            let fallbackPresearchComponents = document.querySelector(
                '.fallback-presearch-components',
            );
            if (fallbackPresearchComponents) {
                fallbackPresearchComponents.style.display = 'block';
            }
        }
    }

    __hidePreSearchSuggestions(hide) {
        if (this.preSearchSuggestions) {
            // Remove previously active suggestion (if any)
            let activePreSearch = this.preSearchSuggestions.querySelector('.active');
            if (activePreSearch) {
                activePreSearch.classList.remove('active');
            }

            if (hide) {
                this.presearchCollectionResultsWrapper.classList.add('hide');
                this.preSearchSuggestions.classList.add('hide');
            } else {
                this.presearchCollectionResultsWrapper.classList.remove('hide');
                this.preSearchSuggestions.classList.remove('hide');
            }
        }
    }

    // START A/B TEST PLGRWEB-1340 : Display show/movie titles on search
    displaySearchResultTitles() {
        if (
            CBS?.AbTestsConfigs?.modules?.SearchResultsDisplayTitles?.activeVariant ===
            SEARCH_TITLE_TEST_VARIANT
        ) {
            let titleWrappers = document.querySelectorAll('.display-result-titles');
            // display titles under search results for variant
            titleWrappers.forEach((elem) => {
                elem.classList.remove('hide');
            });
        }
    }
    // END A/B TEST PLGRWEB-1340 : Display show/movie titles on search
}
